import { render, staticRenderFns } from "./TestimonialCard.vue?vue&type=template&id=72f0f7fa&"
import script from "./TestimonialCard.vue?vue&type=script&lang=js&"
export * from "./TestimonialCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f0f7fa')) {
      api.createRecord('72f0f7fa', component.options)
    } else {
      api.reload('72f0f7fa', component.options)
    }
    module.hot.accept("./TestimonialCard.vue?vue&type=template&id=72f0f7fa&", function () {
      api.rerender('72f0f7fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cards/TestimonialCard.vue"
export default component.exports